import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Form from 'component/utils/Form'
import Select from 'component/Select/Select'
import HierarchySelect from 'component/hierarchy/HierarchySelectNew'
import CloseIconSVG from 'component/svgComponents/close'

const FIELDS = [
  'sectionId',
  'subSectionId',
  'typeId',
  'subTypeId',
  'idDatasheetFormatList',
]

class DatasheetManagementForm extends Component {
  static propTypes = {
    datasheetFormatList: PropTypes.array.isRequired,
    setValueToField: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    setSideFilterVisible: PropTypes.func.isRequired,
    filterValues: PropTypes.object,
    handleFilter: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { filterValues, setValueToField } = this.props

    Object.keys(filterValues).forEach((field) =>
      setValueToField(field, filterValues[field])
    )
  }

  handleChange(field, { value } = {}) {
    const { setValueToField } = this.props

    const fields = ['sectionId', 'subSectionId', 'typeId', 'subTypeId']

    setValueToField(field, value)
    fields
      .slice(fields.indexOf(field) + 1)
      .forEach((f) => setValueToField(f, ''))
    if (field === 'typeId') setValueToField('idDatasheetFormatList', [])
  }

  handleChangeMultiSelect = (formats) => {
    const { setValueToField } = this.props

    setValueToField('idDatasheetFormatList', formats)
  }

  render() {
    const {
      datasheetFormatList,
      translate,
      user,
      values,
      setSideFilterVisible,
      filterValues,
      handleFilter,
    } = this.props

    const isFilterEmpty = !values.sectionId;
      
    return (
      <div className='right-filter-container'>
        <CloseIconSVG className="right-filter-svg"
          onClick={() => setSideFilterVisible(filterValues)}
        />
        <h3 className='margin-bottom-triple'>
          <strong>{translate('mobile.filter')}</strong>
        </h3>
        <div>
          <HierarchySelect
            fill
            label={translate('section')}
            id='sectionId'
            field='sectionId'
            name='sectionId'
            onChange={(values) => this.handleChange('sectionId', values)}
            placeholder='select.section'
            query={{ level: 2 }}
            translate={translate}
            user={user}
            value={values.sectionId}
            required
            clearButton
            concatId
          />
        </div>
        <div>
          <HierarchySelect
            fill
            label={translate('subSection')}
            id='subSectionId'
            field='subSectionId'
            name='subSectionId'
            onChange={(values) => this.handleChange('subSectionId', values)}
            placeholder='select.subsection'
            query={{
              level: 3,
              sectionId: values.sectionId,
            }}
            translate={translate}
            user={user}
            value={values.subSectionId}
            required
            disabled={!values.sectionId}
            clearButton
            concatId
          />
        </div>
        <div>
          <HierarchySelect
            fill
            label={translate('type')}
            id='typeId'
            field='typeId'
            name='typeId'
            onChange={(values) => this.handleChange('typeId', values)}
            placeholder='select.type'
            query={{
              level: 4,
              sectionId: values.sectionId,
              subSectionId: values.subSectionId,
            }}
            translate={translate}
            user={user}
            value={values.typeId}
            required
            disabled={!values.subSectionId}
            clearButton
            concatId
          />
        </div>
        <div>
          <HierarchySelect
            fill
            label={translate('subType')}
            id='subTypeId'
            field='subTypeId'
            name='subTypeId'
            onChange={(values) => this.handleChange('subTypeId', values)}
            placeholder='select.subtype'
            query={{
              level: 5,
              sectionId: values.sectionId,
              subSectionId: values.subSectionId,
              typeId: values.typeId,
            }}
            translate={translate}
            user={user}
            value={values.subTypeId}
            required
            disabled={!values.typeId}
            clearButton
            concatId
          />
        </div>
        <div>
          <Select
            isMulti
            rightIcon={
              (values.idDatasheetFormatList || '').length
                ? 'glyph glyph-x hierarchy-clear-button'
                : ''
            }
            onRightIconClick={() => this.handleChangeMultiSelect([])}
            label={translate('datasheetManagement.format')}
            options={datasheetFormatList.map((df) => ({
              value: df.idDatasheetFormat,
              label: df.nmDatasheetFormat,
            }))}
            placeholder={translate('select.format')}
            translate={translate}
            onChange={(values) => this.handleChangeMultiSelect(values)}
            value={values.idDatasheetFormatList}
            required
            disabled={!!values.typeId}
          />
        </div>
        <button
          className='btn btn-primary button-full margin-top-filter-button'
          disabled={isFilterEmpty}
          onClick={() => handleFilter(values)}
          type='button'
        >
          {translate('btn.filter')}
        </button>
      </div>
    )
  }
}

export default Form({ fields: FIELDS })(DatasheetManagementForm)
export { DatasheetManagementForm }
